import { z } from 'zod';

export const getIsEmployeeZodSchema = z
  .object({
    isEmployee: z.boolean(),
  })
  .transform((v): { isEmployee: boolean } => {
    return v;
  });
